
  export default function orderByScore(payload){
    return{
        type: "ORDER_BY_SCORE",
        payload,
      }
    }